export const FACILITY_HEADER_SAVED = "Charisma.Leasing.PublishedLanguage.Events.LeasingFacility.FacilityHeaderSaved";
export const FACILITY_HEADER_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingFacility.FacilityHeaderInvalidated";
export const TRANSFER_FACILITY_TO_ERP_EXECUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingFacility.TransferFacilityDocumentToERPExecuted";
